<template>
    <PageLoading :loading="loading">
        <!-- 错误页面 -->
        <ErrorPage v-if="hasError" :title="errorTitle" :message="errorMessage" />

        <!-- 正常页面 -->
        <div v-else class="order-detail-page">
            <!-- 学生信息 -->
            <div class="student-info-section">
                <div class="student-name">{{ orderDetail.student_name }}</div>
                <div class="student-details">{{ orderDetail.place_name }}/{{ orderDetail.grade_name }}/{{ orderDetail.class_name }}</div>
            </div>

            <!-- 搭配套餐：仅赠送套卡时隐藏 -->
            <div class="package-section" v-if="!orderDetail.is_present_card">
                <div class="section-title">搭配套餐</div>
                <div class="milk-week-list">
                    <div class="milk-week-item" v-for="(item, index) in orderDetail.packages" :key="index">
                        <div class="milk-week-card">
                            <div class="milk-week-title">{{ item.day }}</div>
                            <div class="milk-type-tag" :style="{ background: item.type === 'fresh' ? '#3B82F6' : '#D50F5F' }">
                                {{ item.type === 'fresh' ? '鲜' : '酸' }}
                            </div>
                            <img class="milk-icon"
                                :src="item.type === 'fresh' ? require('@/assets/milk-fresh.png') : require('@/assets/milk-yogurt.png')" />
                            <div class="milk-label" :style="{ color: item.type === 'fresh' ? '#3B82F6' : '#D50F5F' }">
                                {{ item.type === 'fresh' ? '鲜奶' : '酸奶' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 订单信息：仅赠送套卡时隐藏部分字段 -->
            <div class="order-info-section">
                <van-row v-if="!orderDetail.is_present_card">
                    <van-col span="12">
                        <div class="info-item">
                            <div class="info-label">开始时间:</div>
                            <div class="info-value">{{ orderDetail.start_send_date }}</div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="info-item">
                            <div class="info-label">结束时间:</div>
                            <div class="info-value">{{ orderDetail.end_date }}</div>
                        </div>
                    </van-col>
                </van-row>
                <van-row v-if="!orderDetail.is_present_card">
                    <van-col span="12">
                        <div class="info-item">
                            <div class="info-label">瓶数:</div>
                            <div class="info-value">{{ orderDetail.sum_num }}</div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="info-item" v-if="orderDetail.state !== '取消'">
                            <div class="info-label">已送瓶数:</div>
                            <div class="info-value">{{ orderDetail.send_num }}</div>
                        </div>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="12">
                        <div class="info-item">
                            <div class="info-label">订单金额:</div>
                            <div class="info-value price">¥{{ orderDetail.order_amount }}</div>
                        </div>
                    </van-col>
                    <van-col span="12" v-if="!orderDetail.is_present_card">
                        <div class="info-item" v-if="orderDetail.state !== '取消'">
                            <div class="info-label">剩余瓶数:</div>
                            <div class="info-value">{{ orderDetail.not_send_num }}</div>
                        </div>
                    </van-col>
                </van-row>
            </div>

            <!-- 订单卡片：有卡片信息时显示（放在订单信息下方） -->
            <div class="order-card-section" v-if="orderDetail.order_card_info && orderDetail.order_card_info.card_no">
                <div class="order-card-display"
                     @click.stop="goToCardDetail(orderDetail.order_card_info)"
                     @click.capture.stop
                     :onclick="orderDetail.order_card_info.card_info_id ? `window.location.href='/card-detail?card_id=${orderDetail.order_card_info.card_info_id}';event.stopPropagation();event.preventDefault();return false;` : ''">
                    <div class="order-card-header">
                        <div class="order-card-title">
                            <svg class="chip-card-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="2" y="4" width="20" height="16" rx="2.5" fill="none" stroke="#8B0000" stroke-width="1.2"/>
                                <rect x="2" y="8.2" width="20" height="2" fill="#8B0000" opacity="0.1"/>
                                <rect x="5" y="12.5" width="5.5" height="3.8" rx="0.6" fill="none" stroke="#8B0000" stroke-width="1.1"/>
                                <line x1="5" y1="13.8" x2="10.5" y2="13.8" stroke="#8B0000" stroke-width="0.9"/>
                                <line x1="5" y1="15" x2="10.5" y2="15" stroke="#8B0000" stroke-width="0.9"/>
                                <line x1="7.75" y1="12.5" x2="7.75" y2="16.3" stroke="#8B0000" stroke-width="0.9"/>
                            </svg>
                            <span>订单卡片</span>
                        </div>
                        <div class="order-card-type-tag">{{ orderDetail.order_card_info.card_type }}</div>
                    </div>
                    <div class="order-card-body">
                        <div class="order-card-row">
                            <span class="order-card-label">卡号：</span>
                            <span class="order-card-value card-no">{{ orderDetail.order_card_info.card_no }}</span>
                        </div>
                        <div class="order-card-row">
                            <span class="order-card-label">剩余：</span>
                            <span class="order-card-value">{{ orderDetail.order_card_info.remaining_text }}</span>
                        </div>
                        <div class="order-card-row">
                            <span class="order-card-label">有效期：</span>
                            <span class="order-card-value">{{ orderDetail.order_card_info.validity_text }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 配送日志：仅赠送套卡时隐藏 -->
            <div class="delivery-log-section" v-if="!orderDetail.is_present_card">
                <div class="delivery-summary">
                    总共<span class="bold">{{ orderDetail.sum_num }}</span>瓶 
                    <span v-if="orderDetail.state !== '取消'">
                        (已送<span class="bold red">{{ orderDetail.send_num }}</span>瓶, 剩余<span class="bold">{{ orderDetail.not_send_num }}</span>瓶)
                    </span>
                </div>
                <div class="delivery-log-list">
                    <div class="delivery-log-item" v-for="item in orderDetail.deliveryLogs" :key="item.id">
                        <div class="log-time">{{ item.pick_up_date }}</div>
                        <div class="log-status">
                            <van-tag round :type="item.state === '已取货' ? 'primary' : (item.state === '未取货' ? 'success' : 'default')"
                                size="medium" class="status-btn">
                                {{ item.state }}
                            </van-tag>
                        </div>
                        <div class="log-count">-{{ item.product_qty }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 暂停取奶按钮：仅赠送套卡的订单不显示 -->
        <div class="pause-milk-btn" v-if="!orderDetail.is_present_card" @click="handlePauseMilk">
            <span>暂停取奶</span>
        </div>

        <!-- 暂停取奶组件 -->
        <PauseDelivery ref="pauseDelivery" :order-id="orderDetail.id" :place-id="orderDetail.place_id" @success="initPage" />
    </PageLoading>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { setWxTitle } from '@/utils/wx'
import { post } from '@/utils/request'
import PauseDelivery from '@/components/PauseDelivery.vue'

// 加载状态
const loading = ref(true)

// 错误状态
const hasError = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')

// 订单详情数据
const orderDetail = ref({})

// 暂停取奶组件引用
const pauseDelivery = ref(null)

// 处理错误
const handleError = (title, message) => {
    hasError.value = true
    errorTitle.value = title
    errorMessage.value = message
    loading.value = false
}

// 跳转到卡片详情
const goToCardDetail = (cardInfo) => {
    if (!cardInfo || !cardInfo.card_info_id) return
    window.location.href = `/card-detail?card_id=${cardInfo.card_info_id}`
}

onMounted(() => {
    setWxTitle('订单详情')
    initPage()
})

// 页面初始化
const initPage = async () => {
    try {
        const urlParams = new URLSearchParams(window.location.search)
        const orderInfo = JSON.parse(decodeURIComponent(urlParams.get('info')))
        console.log(orderInfo)
        // 这里可以调用接口获取订单详情数据
        const res = await post('/api/select/community/order', {
            order_id: orderInfo.id,
            partner_id: parseInt(localStorage.getItem('userId')),
            company_ids: JSON.parse(localStorage.getItem('company_ids')),
            business_type: '校园订奶',
        })
        if (res.result && res.result.state === 'ok') {
            orderDetail.value = {
                ...orderInfo,
                deliveryLogs: res.result.order_arr[0].send_detail_arr,
            }
        } else {
            handleError('加载失败', res.result?.message || '接口异常')
        }
    } catch (error) {
        console.error('页面初始化失败:', error)
        handleError('加载失败', '页面加载失败，请重试')
    } finally {
        loading.value = false
    }
}

// 处理暂停取奶
const handlePauseMilk = () => {
    console.log('暂停取奶')
    // 调用暂停取奶组件的show方法
    if (pauseDelivery.value) {
        pauseDelivery.value.show()
    }
}
</script>

<style scoped>
.order-detail-page {
    background: #f5f5f5;
    min-height: 100vh;
}

.student-info-section {
    background: #fff;
    padding: 20px 16px;
    margin-bottom: 12px;
}

.student-name {
    font-size: 18px;
    font-weight: 600;
    color: #1F2937;
    margin-bottom: 4px;
}

.student-details {
    font-size: 14px;
    color: #6B7280;
}

.package-section {
    background: #fff;
    margin-bottom: 12px;
    padding: 16px;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1F2937;
    margin-bottom: 12px;
}

.milk-week-list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
}

.milk-week-item {
    display: flex;
    justify-content: center;
}

.milk-week-card {
    border: 1px solid #E5E7EB;
    border-radius: 7px;
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 54px;
    position: relative;
}

.milk-week-title {
    font-size: 14px;
    font-weight: 500;
}

.milk-type-tag {
    position: absolute;
    top: 34px;
    right: 2px;
    color: #fff;
    font-size: 11px;
    font-weight: 500;
    border-radius: 50%;
    width: 21px;
    height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
}

.milk-icon {
    width: 16px;
    height: 32px;
    margin: 18px 0;
    display: block;
}

.milk-label {
    font-size: 11px;
    font-weight: 500;
}

.order-info-section {
    background: #fff;
    margin-bottom: 12px;
    padding: 16px;
}

.order-info-section .van-row {
    margin-bottom: 12px;
}

.order-info-section .van-row:last-child {
    margin-bottom: 0;
}

.info-item {
    display: flex;
    align-items: center;
    gap: 8px;
}

.info-label {
    font-size: 14px;
    color: #6B7280;
}

.info-value {
    font-size: 14px;
    color: #1F2937;
    font-weight: 500;
}

.info-value.price {
    color: var(--van-primary-color);
    font-weight: 600;
}

.delivery-log-section {
    background: #fff;
    margin-bottom: 12px;
    padding: 16px;
}

.delivery-summary {
    font-size: 16px;
    color: #1F2937;
    margin-bottom: 16px;
}

.bold {
    font-weight: 600;
}

.red {
    color: var(--van-primary-color);
}

.delivery-log-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.delivery-log-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background: #f9f9f9;
    border-radius: 8px;
}

.log-time {
    font-size: 14px;
    color: #1F2937;
    font-weight: 500;
}

.log-status {
    display: flex;
    align-items: center;
}

.status-btn.van-tag--primary {
    background: #609DFF;
}

.log-count {
    font-size: 14px;
    color: #1F2937;
    font-weight: 500;
}

/* 订单卡片样式 */
.order-card-section {
    margin-top: 16px;
    margin-bottom: 4px;
    padding: 0 16px;
}

.order-card-display {
    background: linear-gradient(135deg, #FDF4F4 0%, #FAECEC 100%);
    border-radius: 12px;
    padding: 16px 18px;
    color: #1F2937;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    z-index: 10;
    -webkit-tap-highlight-color: rgba(139, 0, 0, 0.05);
    border-left: 3px solid #8B0000;
}

.order-card-display * {
    pointer-events: none;
}

.order-card-display:active {
    transform: scale(0.995);
    background: linear-gradient(135deg, #FAECEC 0%, #F6E3E3 100%);
}

.chip-card-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.order-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.order-card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #8B0000;
}

.order-card-type-tag {
    background: rgba(139, 0, 0, 0.12);
    color: #8B0000;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
}

.order-card-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.order-card-row {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.order-card-label {
    color: #6B7280;
    flex-shrink: 0;
    width: 60px;
    font-size: 13px;
}

.order-card-value {
    font-weight: 500;
    flex: 1;
    color: #374151;
}

.order-card-value.card-no {
    letter-spacing: 1.2px;
    font-size: 14px;
    color: #8B0000;
    font-weight: 600;
}

/* 暂停取奶按钮 */
.pause-milk-btn {
    position: fixed;
    right: 16px;
    bottom: 20px;
    background: var(--van-primary-color);
    color: #fff;
    padding: 12px 16px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 4px 12px rgba(139, 0, 0, 0.3);
    z-index: 999;
    cursor: pointer;
    transition: all 0.3s ease;
}
</style>